// @flow

import React from "react";
import { connect } from "react-redux";

import { Content, ContentLayout } from "@src/components";
import { riskColorMapping } from "@src/common/colors";

import NavigationButtons from "@src/containers/Assessment/Navigation";
import { RiskHeader } from "@src/containers/Assessment/components";
import { updateComment, calculateRisk } from "@src/actions";

// Content Containers Layouts
import RiskIndicators from "./Layouts/RiskIndicators";
import RiskRatings from "./Layouts/RiskRatings";
import ContributingFactors from "./Layouts/ContributingFactors";

const SECTION_MAPPER = {
  0: "riskindicators",
  1: "riskratings",
  2: "contributingfactors"
};

function getLayOut(section) {
  switch (section) {
    case 0:
      return RiskIndicators;
    case 1:
      return RiskRatings;
    case 2:
      return ContributingFactors;
    default:
    // Do nothing
  }
}

class ContentWrapper extends React.Component {
  state = {
    showConfirmDialog: false,
    showContinueOnStageA: false,
    disabledCompleteOnStageA: true
  };

  componentWillMount() {
    // TODO: if (this.props.careType === null) {
    // this.props.history.replace("/");
    // }
  }

  enableCompleteOnStageA = () =>
    this.setState({ disabledCompleteOnStageA: false });

  render() {
    const { careType, sections, stepsMeta, riskScore } = this.props;
    const { activeStep, activeSubStep } = stepsMeta;

    // Section
    const section = sections[SECTION_MAPPER[activeStep]];

    // CareType
    const careTypeTitle = sections["riskratings"][careType].type;

    // RiskScore
    let riskTypeText = "In Progress";
    let riskColor = "white";
    let fontColor;
    if (riskScore !== null) {
      riskTypeText = sections.riskratings[careType].risks[riskScore].type;
      riskColor = riskColorMapping[riskScore];
      fontColor = riskScore === 0 ? "black" : "white"; // "Very low" risk score uses black text
    }

    // Comment
    const commentValue =
      (Boolean(section.subsections)
        ? section.subsections[activeSubStep].comments
        : section.comments) || "";

    // Layout Component
    let Component = getLayOut(activeStep);

    return (
      <Content flex={2} justifyContent="flex-start">
        <RiskHeader
          dialogTitle={`SECTION ${section.label}: ${section.title} - ${careTypeTitle}`}
          dialogSubTitle={`Risk Rating: ${riskTypeText}`}
          riskColor={riskColor}
          fontColor={fontColor}
        />
        <ContentLayout marginT={8} boxShadow>
          <Component
            section={section}
            activeStep={activeStep}
            activeSubStep={activeSubStep}
            careType={careType}
            careTypeTitle={careTypeTitle}
            disabledCompleteOnStageA={this.state.disabledCompleteOnStageA}
            enableCompleteOnStageA={this.enableCompleteOnStageA}
            riskScore={riskScore}
            onCommentChange={e =>
              this.props.updateComment(
                e.target.value,
                SECTION_MAPPER[activeStep],
                activeSubStep
              )}
            commentValue={commentValue}
            showConfirmDialog={this.state.showConfirmDialog}
            hideConfirmDialog={() =>
              this.setState({
                showConfirmDialog: !this.state.showConfirmDialog,
                showContinueOnStageA: true
              })}
            riskColor={riskColor}
            riskTypeText={riskTypeText}
          />
          <NavigationButtons
            disabledComplete={this.state.disabledCompleteOnStageA}
            showDialog={() => {
              this.props.calculateRisk();
              this.setState({ showConfirmDialog: true });
            }}
            showContinueOnStageA={this.state.showContinueOnStageA}
          />
        </ContentLayout>
      </Content>
    );
  }
}

function mapStateToProps(store) {
  return {
    stepsMeta: store.sideBar.stepsMeta,
    careType: store.app.careType,
    sections: store.app.sections,
    riskScore: store.app.riskScore,
    appState: store.app
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateComment: (value, section, subStep) =>
      dispatch(updateComment(value, section, subStep)),
    calculateRisk: () => dispatch(calculateRisk())
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentWrapper);



// WEBPACK FOOTER //
// ./src/containers/Assessment/ContentWrapper/index.jsx